import React from 'react';
import '../UploadForm.css';

function ShowMoreKeywordsButton({ onClick, disabled, isLoading, shouldShow }) {
  if (!shouldShow) return null;
  return (
    <button onClick={onClick} disabled={disabled} className="show-more-keywords-button">
      {isLoading ? 'Loading...' : 'Show More Keywords'}
    </button>
  );
}

export default ShowMoreKeywordsButton;


